import Vue from "vue";
import Vuetify from "vuetify"; // ⬅️ full build (not vuetify/lib)
import "vuetify/dist/vuetify.min.css"; // ⬅️ core CSS
import "@mdi/font/css/materialdesignicons.css"; // ⬅️ icon font CSS
import preset from "./default-preset/preset";

Vue.use(Vuetify);

export default new Vuetify({
    preset,
    icons: {
        iconfont: "mdi", // ⬅️ use the font icons (mdi), not mdiSvg
    },
    theme: {
        options: {
            customProperties: true,
            variations: false,
        },
    },
});
